export const UNKNOWN_DIMENSION_NAMES: Record<string, string> = {
  UNKNOWN_LINE_ITEM_NAME: 'Unknown Ad Group',
  UNKNOWN_MEDIA_TYPE_NAME: 'Unknown Media Type',
  UNKNOWN_AUDIENCE_NAME: 'Unknown Audience',
};
